import {
  DOCUMENT_ALLOWED_CURRENCIES,
  type DocumentCurrencyCode,
  normalizeDocumentCurrency,
} from "./document-currencies";

export type IssuerBankAccountEntry = {
  accountNumber: string;
  accountName: string;
  /** MinIO key ຫຼື path — ຮູບ QR ຮັບເງິນຕາມສະກຸນ (ສະແດງໃນ Invoice) */
  qrCodeImageKey: string | null;
};

export type IssuerBankAccountsByCurrency = Record<
  DocumentCurrencyCode,
  IssuerBankAccountEntry
>;

export const EMPTY_ISSUER_BANK_ACCOUNTS: IssuerBankAccountsByCurrency = {
  LAK: { accountNumber: "", accountName: "", qrCodeImageKey: null },
  THB: { accountNumber: "", accountName: "", qrCodeImageKey: null },
  USD: { accountNumber: "", accountName: "", qrCodeImageKey: null },
};

export function normalizeIssuerBankAccounts(
  raw: unknown,
): IssuerBankAccountsByCurrency {
  const base: IssuerBankAccountsByCurrency = {
    LAK: { ...EMPTY_ISSUER_BANK_ACCOUNTS.LAK },
    THB: { ...EMPTY_ISSUER_BANK_ACCOUNTS.THB },
    USD: { ...EMPTY_ISSUER_BANK_ACCOUNTS.USD },
  };
  if (!raw || typeof raw !== "object") return base;
  const o = raw as Record<string, unknown>;
  for (const c of DOCUMENT_ALLOWED_CURRENCIES) {
    const e = o[c];
    if (e && typeof e === "object") {
      const x = e as Record<string, unknown>;
      const qrRaw = x.qrCodeImageKey;
      const qrCodeImageKey =
        typeof qrRaw === "string" && qrRaw.trim() ? qrRaw.trim() : null;
      base[c] = {
        accountNumber:
          typeof x.accountNumber === "string" ? x.accountNumber : "",
        accountName: typeof x.accountName === "string" ? x.accountName : "",
        qrCodeImageKey,
      };
    }
  }
  return base;
}

export function mergeIssuerBankAccounts(
  input: Partial<IssuerBankAccountsByCurrency> | undefined,
): IssuerBankAccountsByCurrency {
  const base = normalizeIssuerBankAccounts(EMPTY_ISSUER_BANK_ACCOUNTS);
  if (!input) return base;
  for (const c of DOCUMENT_ALLOWED_CURRENCIES) {
    const row = input[c];
    if (row) {
      const qr = row.qrCodeImageKey;
      base[c] = {
        accountNumber: (row.accountNumber ?? "").trim(),
        accountName: (row.accountName ?? "").trim(),
        qrCodeImageKey: typeof qr === "string" && qr.trim() ? qr.trim() : null,
      };
    }
  }
  return base;
}

export function getIssuerBankAccountForCurrency(
  currency: string | null | undefined,
  bankAccounts: IssuerBankAccountsByCurrency,
): IssuerBankAccountEntry {
  const code = normalizeDocumentCurrency(currency);
  return bankAccounts[code];
}

export function issuerBankAccountHasAnyValue(
  entry: IssuerBankAccountEntry,
): boolean {
  return Boolean(
    entry.accountNumber.trim() ||
      entry.accountName.trim() ||
      (entry.qrCodeImageKey?.trim() ?? ""),
  );
}
